(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rc-delivery-notice"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('rc-delivery-notice')) return;

    const calendar = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Amsterdam', year: 'numeric', month: '2-digit', day: '2-digit'
    });
    const months = ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'];

    class RCDeliveryNotice extends HTMLElement {
      static get observedAttributes() {
        return ['data-min-days', 'data-max-days'];
      }

      connectedCallback() {
        this.updateDates();
      }

      attributeChangedCallback() {
        if (this.isConnected) this.updateDates();
      }

      updateDates(now = new Date()) {
        const days = (value, fallback) => {
          const parsed = Number.parseInt(value, 10);
          return Number.isFinite(parsed) ? Math.min(30, Math.max(0, parsed)) : fallback;
        };
        const minDays = days(this.dataset.minDays, 2);
        const maxDays = Math.max(minDays, days(this.dataset.maxDays, 4));
        const singleDate = minDays === maxDays;
        const intro = this.querySelector('[data-delivery-intro]');
        const introText = singleDate ? this.dataset.introSingle : this.dataset.introRange;
        if (intro && introText != null) intro.textContent = introText;
        for (const selector of ['[data-delivery-separator]', '[data-delivery-until]', '[data-delivery-end]']) {
          const element = this.querySelector(selector);
          if (element) element.hidden = singleDate;
        }
        const parts = Object.fromEntries(calendar.formatToParts(now).map(part => [part.type, part.value]));
        const year = Number(parts.year);
        const month = Number(parts.month) - 1;
        const day = Number(parts.day);
        for (const [selector, offset] of [['[data-delivery-start]', minDays], ['[data-delivery-end]', maxDays]]) {
          const time = this.querySelector(selector);
          if (!time) continue;
          const date = new Date(Date.UTC(year, month, day + offset));
          time.dateTime = date.toISOString().slice(0, 10);
          time.textContent = `${date.getUTCDate()} ${months[date.getUTCMonth()]}`;
        }
      }
    }

    customElements.define('rc-delivery-notice', RCDeliveryNotice);

    const refresh = () => {
      if (document.hidden) return;
      const now = new Date();
      document.querySelectorAll('rc-delivery-notice').forEach(notice => notice.updateDates(now));
    };
    window.addEventListener('pageshow', refresh);
    document.addEventListener('visibilitychange', refresh);
    window.setInterval(refresh, 60000);
  })();
  } catch(e) { console.error(e); }
})();

})();
